import { render, staticRenderFns } from "./ProductsWithVideo.vue?vue&type=template&id=e8decdb4&scoped=true&"
import script from "./ProductsWithVideo.vue?vue&type=script&lang=js&"
export * from "./ProductsWithVideo.vue?vue&type=script&lang=js&"
import style0 from "./ProductsWithVideo.vue?vue&type=style&index=0&id=e8decdb4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8decdb4",
  null
  
)

export default component.exports